module.exports = __webpack_public_path__ + "static/lisa-b7519f55100c94e088ea8d0c36dce9af.png";